import React from 'react';

const FunnelChart = ({ data, isLoading }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-sm" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
          Loading funnel data...
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-sm" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
          No funnel data available
        </div>
      </div>
    );
  }

  // Shades of #1d0c46 (darkest to lightest)
  const funnelSteps = [
    { label: 'Unique Users', value: data.uniqueUsers || 0, color: '#1d0c46' },
    { label: 'Web3 Users', value: data.web3Users || 0, color: '#3d2d66' },
    { label: 'Wallets Connected', value: data.walletsConnected || 0, color: '#5d4d86' },
    { label: 'Transacted', value: data.transacted || 0, color: '#8b7bb6' }
  ];

  const maxValue = Math.max(funnelSteps[0]?.value || 1, 1);

  return (
    <div className="flex items-end justify-center gap-4 h-80">
      {funnelSteps.map((step, index) => {
        const percentage = maxValue > 0 ? (step.value / maxValue) * 100 : 0;
        const conversionRate = index > 0 && funnelSteps[index - 1].value > 0 ? 
          ((step.value / funnelSteps[index - 1].value) * 100).toFixed(1) : 100;

        return (
          <div key={step.label} className="flex flex-col items-center flex-1 h-full">
            {/* Bar Container */}
            <div className="flex-1 w-full flex items-end relative" style={{ minHeight: '200px' }}>
              <div 
                className="w-full transition-all duration-500 flex flex-col justify-end items-center relative"
                style={{ 
                  height: `${Math.max(percentage, 5)}%`,
                  backgroundColor: step.color,
                  minHeight: percentage > 0 ? '20px' : '0px'
                }}
              >
                {/* Value inside bar */}
                <span className="text-white font-semibold text-xs mb-1" style={{ fontFamily: 'Raleway, sans-serif' }}>
                  {step.value.toLocaleString()}
                </span>
                {/* Conversion rate badge */}
                {index > 0 && (
                  <span className="text-white text-xs opacity-90 mb-1" style={{ fontFamily: 'Raleway, sans-serif' }}>
                    {conversionRate}%
                  </span>
                )}
              </div>
            </div>
            
            {/* Label below bar */}
            <div className="mt-2 text-center">
              <div className="text-xs font-medium mb-1" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
                {step.label}
              </div>
              <div className="text-xs" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
                {percentage.toFixed(1)}%
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelChart;
